<template>
<!-- :size="option.attribute.size" -->
  <t-form
    :requiredMark="option.attribute.required"
    :labelAlign="option.attribute.labelAlign"
  >
    <t-form-item
      class="my_amount"
      :label="option.attribute.label"
      :style="setStyles"
    >
      <t-input-number
        theme="normal"
        class="my_amount_item"
        v-model="iptVal"
        :placeholder="option.attribute.placeholder"
        :align="option.attribute.align"
        :decimal-places="2"
        :style="setStyles"
        :status="message"
        :tips="tips"
        @change="checkValue"
      />
    </t-form-item>
    <!-- <t-button @click="test()">确定</t-button> -->
  </t-form>
</template>

<script>
import {
  getDataJson,
  pollingRefresh,
  hasNonEmptyValues,
  hasProperty,
} from "@/utils/refresh-cpt-data";
export default {
  name: "cpt-amount",
  props: {
    option: Object,
    refMap: Object,
    current:Object,
  },
  computed: {
    setStyles() {
      return {
        // "--labelWidth":this.option.attribute.labelWidth + "px",
       "--width": this.current.cptWidth + "px",
        "--height": this.option.attribute.height + "px",
        "--indent": this.option.attribute.indent + "px",
        "--bgColor": this.option.attribute.bgColor,
        "--textColor": this.option.attribute.textColor,
        "--placholderColor": this.option.attribute.textPlaceholderColor,
        "--fontStyle": this.option.attribute.fontStyle,
        "--fontWeight": this.option.attribute.fontWeight,
        "--fontFamily": this.option.attribute.fontFamily,
        "--fontSize": this.option.attribute.fontSize + "px",
        "--borderSize": this.option.attribute.borderSize + "px",
        "--borderColor": this.option.attribute.borderColor,
        "--borderRadius": this.option.attribute.borderRadius + "px",
        "--lineType": this.option.attribute.lineType,
      };
    },
    dataReload(){
      return this.option.attribute.globalDataReload || [0]
    }
  },
  data() {
    return {
      iptVal: "",
      newData: "",
      jsFunFlag: false,
      message: "default",
      tips: "",
      uuid:null,
    };
  },
  watch: {
    // "option.attribute": {
    //   handler() {
    //     this.processData(this.option.cptDataForm, this.newData, this.jsFunFlag);
    //   },
    //   deep: true,
    // },
    "current.cptShow"(val){
      if (val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
    "option.attribute.hideCompInTab"(val){
      // 组合选项卡内显示时
      if (!val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    }
  },
  created() {
    this.uuid = require("uuid").v1();
    // 新增属性兼容旧代码
    if (!this.option.attribute.globalDataReload) {
      this.option.attribute.globalDataReload = [0]
    }
 
    if (this.dataReload.includes(0)) {
      this.refreshCptData();
    }
  },
  methods: {
    refreshCptData(cptDataForm = this.option.cptDataForm, paras) {
      pollingRefresh(this.uuid, cptDataForm, () =>
        this.loadData(cptDataForm, paras)
      );
    },
    loadData(cptDataForm, paras) {
      const that = this;
      getDataJson(cptDataForm, paras, (res) => {
        that.newData =
          cptDataForm.dataSource == "4" && hasProperty(res, "jsFunction")
            ? res.resStr
            : res; //相同数据集只调用一次接口原因
        that.jsFunFlag =
          cptDataForm.dataSource == "4" && hasProperty(res, "jsFunction")
            ? res.jsFunction
            : false; //相同数据集只调用一次接口原因
        that.processData(cptDataForm, that.newData, that.jsFunFlag);
      });
    },
    processData(cptDataForm, res, jsFunFlag,isFromGrid) {
      // 第一层判断 如果选择数据集
      if (cptDataForm.dataSource == "4") {
            if(this.current.cptOption.interaction.fatherGridId && isFromGrid != 'ninegrid')return

        // 第二层判断 ，如果没有配转换脚本
        if (jsFunFlag) {
              //判断此控件在九宫格里面就不请求数据
          // 没有全部配置映射字段
          if (hasNonEmptyValues(this.option.attribute.cptTableData)) {
            const dataKey = this.option.attribute.cptTableData;
            let newres = [];
            let newObj = { ...res[0] };
            newObj[dataKey[0].namekey] = newObj[dataKey[0].value];
            newres.push(newObj);
            this.iptVal = newres[0].value;
          }
        } else {
          // 如果配置了转换脚本
          this.iptVal = res.value;
        }
      } else {
        // 不是数据集类型，是静态数据
        this.iptVal = res.value;
      }
    },
    // 校验方法
    checkValue() {
      const { attribute } = this.option;
      console.log(this.iptVal, 'this.iptVal')
      if (attribute.required && !this.iptVal) {
        this.setValidationMessage(false);
        return false;
      } else {
        this.setValidationMessage(true);
        return true;
      }
    },
    setValidationMessage(isValid) {
      this.message = isValid ? "default" : "error";
      this.tips = isValid ? "" : `${this.option.attribute.label}必填`;
    },
    getValue() {
      return this.iptVal
    },
    setValue(value) {
      this.iptVal = value
    }
    // test() {
    //   console.log(this.checkValue(),'-----')
    // }
  },
};
</script>

<style scoped>
.t-form :deep(.t-form__controls){
  margin-left: 0px !important;
}
.t-form :deep(.t-form__controls-content) > div{
  width: 100%;
}
.my_amount /deep/.t-form__label {
  /* width:var(--labelWidth) !important; */
  color: var(--textColor);
  font-style: var(--fontStyle);
  font-weight: var(--fontWeight);
  font-family: var(--fontFamily);
  font-size: var(--fontSize);
  line-height: var(--height);
}

.my_amount /deep/ .t-input .t-input__inner::placeholder {
  color: var(--placholderColor);
}

.my_amount /deep/ .t-input {
  width: 100%;
  height: var(--height);
}

.my_amount_item /deep/ .t-input {
  background-color: var(--bgColor);
  border-width: var(--borderSize);
  border-color: var(--borderColor);
  border-radius: var(--borderRadius);
  border-style: var(--lineType);
}

.my_amount_item /deep/ .t-input .t-input__inner {
  padding-left: var(--indent);
  color: var(--textColor);
  font-style: var(--fontStyle);
  font-weight: var(--fontWeight);
  font-family: var(--fontFamily);
  font-size: var(--fontSize);
}

.my_amount_item /deep/.t-input:focus {
     box-shadow: none !important;
     border-color:var(--borderColor);
}

.my_amount_item /deep/.t-input:hover {
     box-shadow: none !important;
     border-color:var(--borderColor);
}

.my_amount_item /deep/.t-input--focused {
     box-shadow: none !important;
     border-color:var(--borderColor);
}

.my_amount_item /deep/.t-is-focused {
     box-shadow: none !important;
     border-color:var(--borderColor);
}

</style>